import React from 'react'
import { Table, Tbody, Td, Th, Thead, Tr } from '@/shared/ui/Table'
import type { FinancePaymentItem } from '../services/financeReportsService'
import { formatMoneyFromCents } from '../utils/money'

type Props = {
  items: FinancePaymentItem[]
}

function fmtDate(iso?: string | null): string {
  if (!iso) return '-'
  try { return new Date(iso).toLocaleString('pt-BR') } catch { return iso }
}

export function FinancePaymentsTable({ items }: Props) {
  if (!items.length) return <div className="text-sm text-foreground/70">Nenhum pagamento encontrado.</div>

  return (
    <div className="overflow-auto">
      <Table>
        <Thead>
          <Tr>
            <Th>Pago em</Th>
            <Th>Cliente</Th>
            <Th>Plano</Th>
            <Th className="text-right">Bruto</Th>
            <Th className="text-right">Ajustes (total)</Th>
            <Th className="text-right">Líquido (total)</Th>
            <Th>Status</Th>
            <Th>Links</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map((it) => (
            <Tr key={it.invoice_id}>
              <Td className="whitespace-nowrap">{fmtDate(it.paid_at)}</Td>
              <Td className="min-w-[260px]">
                <div className="font-medium">{it.account_name || '-'}</div>
                <div className="text-xs text-foreground/70">{it.owner_email || ''}</div>
                <div className="text-[11px] text-foreground/60">{it.invoice_id}</div>
              </Td>
              <Td className="min-w-[180px]">
                <div className="font-medium">{it.plan_name || it.plan_id || '-'}</div>
                <div className="text-xs text-foreground/70">{it.plan_interval ? String(it.plan_interval).toUpperCase() : ''}</div>
              </Td>
              <Td className="text-right whitespace-nowrap">{formatMoneyFromCents(it.amount_paid_cents, it.currency)}</Td>
              <Td className="text-right whitespace-nowrap">{formatMoneyFromCents(it.adjustments_total_cents, it.currency)}</Td>
              <Td className="text-right whitespace-nowrap font-semibold">{formatMoneyFromCents(it.net_total_cents, it.currency)}</Td>
              <Td className="whitespace-nowrap">{it.status || '-'}</Td>
              <Td className="whitespace-nowrap">
                <div className="flex items-center gap-2">
                  {it.hosted_invoice_url && (
                    <a className="text-xs text-primary hover:underline" href={it.hosted_invoice_url} target="_blank" rel="noreferrer">
                      Stripe
                    </a>
                  )}
                  {it.invoice_pdf && (
                    <a className="text-xs text-primary hover:underline" href={it.invoice_pdf} target="_blank" rel="noreferrer">
                      PDF
                    </a>
                  )}
                </div>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </div>
  )
}

